import React from 'react';
import { Button } from '../ui/button';
import { Switch } from '../ui/switch';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from '../ui/dialog';
import { Loader2, Send, Bell } from 'lucide-react';
import { formatDate } from '../../lib/utils';

export function PublishDialog({
  open,
  onClose,
  onPublish,
  draftCount,
  weekDates,
  sendNotifications,
  setSendNotifications,
  publishing,
}) {
  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="max-w-md">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <Send size={18} className="text-green-600" />
            Publish Schedule
          </DialogTitle>
          <DialogDescription>
            This will make all draft shifts visible to your employees.
          </DialogDescription>
        </DialogHeader>

        <div className="space-y-4 py-2">
          <div className="p-4 bg-green-50 border border-green-200 rounded-lg">
            <div className="flex items-center justify-between text-sm">
              <span className="text-slate-600">Draft shifts to publish:</span>
              <span className="font-bold text-green-700 text-lg">{draftCount}</span>
            </div>
            <div className="flex items-center justify-between text-sm mt-2">
              <span className="text-slate-600">Week:</span>
              <span className="font-medium text-slate-800">
                {weekDates.length > 0 && `${formatDate(weekDates[0])} – ${formatDate(weekDates[6])}`}
              </span>
            </div>
          </div>

          <div className="flex items-center justify-between p-3 border border-slate-200 rounded-lg">
            <div className="flex items-center gap-2">
              <Bell size={16} className="text-slate-500" />
              <div>
                <p className="text-sm font-medium text-slate-900">Notify employees</p>
                <p className="text-xs text-slate-500">Send push notifications when published</p>
              </div>
            </div>
            <Switch
              checked={sendNotifications}
              onCheckedChange={setSendNotifications}
              data-testid="publish-notify-toggle"
            />
          </div>
        </div>

        <div className="flex gap-3 pt-2">
          <Button
            variant="outline"
            className="flex-1"
            onClick={onClose}
            disabled={publishing}
            data-testid="publish-cancel-btn"
          >
            Cancel
          </Button>
          <Button
            className="flex-1 bg-green-600 hover:bg-green-700"
            onClick={onPublish}
            disabled={publishing || draftCount === 0}
            data-testid="publish-confirm-btn"
          >
            {publishing ? (
              <Loader2 className="h-4 w-4 animate-spin mr-2" />
            ) : (
              <Send size={14} className="mr-2" />
            )}
            Publish {draftCount} Shift{draftCount !== 1 ? 's' : ''}
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
